import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { DirectivesUpgradedModule } from '../../directives/directivesUpgraded.module'
import { DateSelectDialogComponent } from './date-select-dialog.component'

@NgModule({
    declarations: [DateSelectDialogComponent],
    exports: [DateSelectDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        DirectivesUpgradedModule,
    ],
})
export class DateSelectDialogModule {}
